import { useEffect, useState } from "react";
import { createHash } from "sha1-uint8array";

// mb-pro-ui-ból ellesve
export function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

// export function isValidTemplate(template: DeviceTemplate | null | undefined) {
//   if (!template) {
//     return false;
//   }
//   if (template && (!template.info || (template as any).type)) {
//     throw new Error("old-template");
//   }
//   return true;
// }

export function genSalt(): Uint8Array {
  return Uint8Array.from({ length: 4 }).map(() => (Math.random() * 256) | 0);
}

export function genSaltString(): string {
  return Buffer.from(genSalt()).toString("hex");
}

function toBytesInt32(num: number): ArrayBuffer {
  const arr = new ArrayBuffer(4); // an Int32 takes 4 bytes
  const view = new DataView(arr);
  view.setUint32(0, num, true); // byteOffset = 0; litteEndian = true
  return arr;
}

export async function hashRfidCard(number: string, salt: string): Promise<string> {
  const saltBuffer = salt.match(/.{1,2}/g)?.map((b) => parseInt(b, 16)) || [];
  const numberFormat = parseInt(number);
  const buffer = toBytesInt32(numberFormat);
  const data = new Uint8Array(buffer);
  const salted = new Uint8Array(data.length + saltBuffer.length);
  salted.set(saltBuffer);
  salted.set(data, saltBuffer.length);
  const hash = createHash().update(salted).digest();
  return Buffer.from(hash).toString("hex");
}

export async function checkRfidCard(number: string, salt: string, checkHash: string): Promise<boolean> {
  const hash = await hashRfidCard(number, salt);
  return hash === checkHash;
}

export function onNumberInputClick(e: React.MouseEvent<HTMLInputElement>) {
  if ((e.target as HTMLInputElement).focus) {
    (e.target as HTMLInputElement).focus();
  }
}

export function getLabel(label: string | { [locale: string]: string }, locale: string) {
  return !label ? "" : typeof label === "string" ? label : label[locale] ?? label.en ?? label[Object.keys(label)[0]];
}

export const useDebounce = <T>(value: T, delay: number) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(handler);
  }, [value, delay]);
  return debouncedValue;
};

export const saveBlobToFile = (blob: Blob, name?: string) => {
  if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) return (window.navigator as any).msSaveOrOpenBlob(blob);

  // For other browsers:
  // Create a link pointing to the ObjectURL containing the blob.
  const data = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = data;
  if (name) {
    link.download = name;
  }

  // this is necessary as link.click() does not work on the latest firefox
  link.dispatchEvent(
    new MouseEvent("click", {
      bubbles: true,
      cancelable: true,
      view: window,
    })
  );

  setTimeout(() => {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data);
    link.remove();
  }, 100);
};
